import {
    ADD_P24_TRANSACTION,
    FETCH_P24_TRANSACTIONS,
    FETCH_P24_TRANSACTION,
    FILTER_P24_TRANSACTIONS,
    FETCH_P24_TRANSACTION_DATA_BYP24,
    FETCH_P24_TRANSACTION_REFUNDS_DATA_BYP24,
    FETCH_P24_TRANSACTION_REFUNDS,
    PAYMENT_METHOD_BLIK_CHARGE_BY_CODE_P24_TRANSACTION,
    REFUND_P24_TRANSACTION
} from "./actionTypes";

import axios from "axios";
import {
    infoAddToast
} from "../components/Toast";
import {
    P24_TRANSACTIONS_URL,
    P24_TRANSACTIONS_BY_FILTER_URL,
    P24_TRANSACTION_URL,
    P24_TRANSACTION_DATA_BY_P24_URL,
    P24_TRANSACTION_REFUNDS_DATA_BY_P24_URL,
    P24_TRANSACTION_REFUNDS_URL,
    P24_TRANSACTION_PAYMENT_METHOD_BLIK_CHARGE_BY_CODE_URL,
    P24_TRANSACTION_REFUND_URL
} from "../../config"

import { FILTER_DATE_FORMAT } from "../constants/dates"

/**
 * Pobieranie listy transakcji p24 z serwera na podstawie filtra
 * 
 * @param {Object} transactionFilter obiekt zawierajacy filtr
 */
export const fetchP24TransactionsByFilter = (transactionFilter) => {
    return dispatch => {
        return axios
            .get(P24_TRANSACTIONS_BY_FILTER_URL, {
                params: {
                    startDate: transactionFilter.startDate.format(FILTER_DATE_FORMAT),
                    endDate: transactionFilter.endDate.format(FILTER_DATE_FORMAT),
                }
            })
            .then(response => {
                dispatch(fetchP24TransactionsSuccess(response.data));
            })
    }
}

/**
 * Pobieranie konkretnej transakcji p24 z serwera
 */
export const fetchP24Transaction = (transactionId) => {
    return dispatch => {
        return axios
            .get(P24_TRANSACTION_URL(transactionId))
            .then(response => {
                dispatch(fetchP24TransactionSuccess(response.data));
            })
    }
}

/**
 * Pobieranie konkretnej transakcji p24 z serwera
 */
export const fetchP24TransactionDataByP24 = (transactionId) => {
    return dispatch => {
        return axios
            .get(P24_TRANSACTION_DATA_BY_P24_URL(transactionId))
            .then(response => {
                dispatch(fetchP24TransactionDataByP24Success(response.data));
            })
    }
}

/**
 * Ustawianie filtru transakcji
 * 
 * @param {Object} transactionFilter obiekt filtru
 */
export const filterP24Transactions = (transactionFilter) => {
    return dispatch => {
        dispatch(filterP24TransactionsSuccess(transactionFilter));
    }
}

/**
 * Pobieranie konkretnej transakcji p24 wraz ze zwrotami z serwera
 */
export const fetchP24TransactionRefundsDataByP24 = (transactionId) => {
    return dispatch => {
        return axios
            .get(P24_TRANSACTION_REFUNDS_DATA_BY_P24_URL(transactionId))
            .then(response => {
                dispatch(fetchP24TransactionRefundsDataByP24Success(response.data));
            })
    }
}

/**
 * Pobieranie zwrotó dla konkretnej transakcji
 */
export const fetchP24TransactionRefunds = (transactionId) => {
    return dispatch => {
        return axios
            .get(P24_TRANSACTION_REFUNDS_URL(transactionId))
            .then(response => {
                dispatch(fetchP24TransactionRefundsSuccess(response.data));
            })
    }
}

/**
 * Tworzenie transakcji na serwerze
 * 
 * @param {P24ImplementationType} p24ImplementationType obiekt implementacji p24
 * @param {object} transaction obiekt transakcji do stworzenia
 */
export const createTransaction = (p24ImplementationType, transaction) => {
    return dispatch => {
        return axios
            .post(`${P24_TRANSACTIONS_URL}`, JSON.stringify(transaction), {
                headers: {
                    "Content-Type": "application/json"
                },
                params: {
                    ...(p24ImplementationType.isDefault ? undefined : { implType: p24ImplementationType.id })
                }
            })
            .then(response => {
                dispatch(createTransactionSuccess(response.data));
                infoAddToast();
            });
    };
};

/**
 * Umożliwia obciążenie transakcji za pomocą kodu T6
 */
export const paymentMethodBlikChargeByCodeP24Transaction = (transactionId, blikCode) => {
    return dispatch => {
        return axios
            .post(P24_TRANSACTION_PAYMENT_METHOD_BLIK_CHARGE_BY_CODE_URL(transactionId), JSON.stringify({ blikCode: blikCode }), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                dispatch(paymentMethodBlikChargeByCodeP24TransactionSuccess(response.data));
            })
    }
}


/**
 * Umożliwia obciążenie transakcji za pomocą kodu T6
 */
export const refundP24Transaction = (transactionId, refundTransaction) => {
    return dispatch => {
        return axios
            .post(P24_TRANSACTION_REFUND_URL(transactionId), JSON.stringify(refundTransaction), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                dispatch(refundP24TransactionSuccess(response.data));
            })
    }
}


/**
 * Akcja pomyślnego pobrania listy transakcji p24 
 * 
 * @param {object} data Obiekt pobranej listy transakcji
 */
const fetchP24TransactionsSuccess = data => {
    return {
        type: FETCH_P24_TRANSACTIONS,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania transakcji p24 
 * 
 * @param {object} data Obiekt pobranej transakcji
 */
const fetchP24TransactionSuccess = data => {
    return {
        type: FETCH_P24_TRANSACTION,
        payload: data
    };
};

/**
 * Akcja pomyślnego ustawienia filtru 
 * 
 * @param {object} data Obiekt filtru
 */
const filterP24TransactionsSuccess = data => {
    return {
        type: FILTER_P24_TRANSACTIONS,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania transakcji p24 
 * 
 * @param {object} data Obiekt pobranej transakcji
 */
const fetchP24TransactionDataByP24Success = data => {
    return {
        type: FETCH_P24_TRANSACTION_DATA_BYP24,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania transakcji p24 wraz ze zwrotami
 * 
 * @param {object} data Obiekt pobranej transakcji
 */
const fetchP24TransactionRefundsDataByP24Success = data => {
    return {
        type: FETCH_P24_TRANSACTION_REFUNDS_DATA_BYP24,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania zwrotow dla wybranej transakcji
 * 
 * @param {object} data Obiekt pobranych zwrotow
 */
const fetchP24TransactionRefundsSuccess = data => {
    return {
        type: FETCH_P24_TRANSACTION_REFUNDS,
        payload: data
    };
};

/**
 * Umożliwia obciążenie transakcji za pomocą kodu T6
 * 
 * @param {object} data Obiekt pobranej transakcji
 */
const paymentMethodBlikChargeByCodeP24TransactionSuccess = data => {
    return {
        type: PAYMENT_METHOD_BLIK_CHARGE_BY_CODE_P24_TRANSACTION,
        payload: data
    };
};

/**
 * Umożliwia obciążenie transakcji za pomocą kodu T6
 * 
 * @param {object} data Obiekt pobranej transakcji
 */
const refundP24TransactionSuccess = data => {
    return {
        type: REFUND_P24_TRANSACTION,
        payload: data
    };
};

/**
 * Akcja pomyślnego utworzenia transakcji
 * 
 * @param {object} data object utworzonej transakcji
 */
const createTransactionSuccess = data => {
    return {
        type: ADD_P24_TRANSACTION,
        payload: data
    };
};